import { createConfig, lazyRoute } from "../config/config-utils"

const SpeakWordsOfSentenceApp = lazyRoute(
  ()=> import("./SpeakWordsOfSentenceApp"),
  "SpeakWordsOfSentenceApp",
)

export const SPEAK_WORDS_OF_SENTENCE_CONFIG = createConfig({
  component: SpeakWordsOfSentenceApp,
  key: "speak-words-of-sentence",
  label: "Speak Words of Sentence",
})
